
class vmLogList {
    constructor(items) {
        if(items) {
            this.items = JSON.parse(JSON.stringify(items));
        } else {
            this.items = [];
        }
    }
    getItems() {
        return this.items;
    }
    getFinishedImportingItemsOnly() {
        return this.items ? this.items.filter((log) => {
            return log.geometries && log.groups && log.vertices;
        }) : [];
    }
    getEntryByTaskEntryId(taskEntryId) {
        return this.items ? this.items.find(log => {
            return log.config.taskEntryId === taskEntryId;
        }) : [];
    }
    getNewestEntry() {
        this.sortByUpdated();
        return this.items[0];
    }
    getOldestEntry() {
        this.sortByUpdated();
        return this.items[this.items.length - 1];
    }
    sortByUpdated() {
        this.items.sort((a, b) => {
            return new Date(b.startedAt) - new Date(a.startedAt);
        });
    }
}

export default vmLogList;